import { Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AbsenceWithTypeData } from '@/domain/requestsPage';
import useRequestInfo from '@/pages/Requests/common/RequestInfo/useRequestInfo';

import InfoWrapper from './InfoWrapper';
import RequestApprover, { ApprovedBy, ApproverTitle } from './RequestApprover';
import RequestComment from './RequestComment';
import RequestCreationDate from './RequestCreationDate';
import RequestPeriod from './RequestPeriod';
import RequestType from './RequestType';

interface IRequestInfoBoxProps {
    className?: string;
    requestDetails: AbsenceWithTypeData;
}

const RequestInfo = ({ requestDetails, className }: IRequestInfoBoxProps) => {
    const { t } = useTranslation();
    const { from, to, typeData, comment, createdAt } = requestDetails;

    const { isWaitingForDeletion, statusData, approverName } = useRequestInfo(requestDetails);

    return (
        <InfoWrapper className={className}>
            <RequestType color={typeData?.color} icon={typeData?.icon} name={typeData?.name} />
            <RequestApprover icon={typeData?.icon} iconColor={typeData?.color}>
                <ApproverTitle title={statusData?.translation} />
                {isWaitingForDeletion && (
                    <Typography variant="created_by">{t('absenceStatus_new_description')}</Typography>
                )}
                {!!approverName && !isWaitingForDeletion && <ApprovedBy name={approverName} />}
            </RequestApprover>
            <RequestPeriod from={from} to={to} />
            <RequestComment comment={comment} />
            <RequestCreationDate createdAt={createdAt} />
        </InfoWrapper>
    );
};

const Memoized = memo(RequestInfo);
const Styled = styled(Memoized)``;

export default Styled;
